import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { PRICING } from "../../data/content";

export default function Pricing() {
  const go = () => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="pricing" data-testid="pricing-section" className="relative py-28 md:py-40 px-6 md:px-10 bg-card/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-mono-x text-primary text-xs tracking-[0.35em]">/ 08 — ENGAGEMENT</span>
          <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl md:text-5xl">Ways to work with us</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {PRICING.map((p, i) => (
            <motion.div key={p.name} data-testid={`pricing-card-${p.name.toLowerCase()}`}
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }}
              className={`relative rounded-3xl p-8 border ${p.highlight ? "border-primary bg-primary/5 shadow-[0_0_50px_hsl(var(--primary)/0.15)]" : "border-border bg-card/40"}`}>
              {p.highlight && <span className="absolute top-6 right-6 font-mono-x text-[10px] tracking-widest bg-primary text-primary-foreground px-3 py-1 rounded-full">POPULAR</span>}
              <h3 className="font-heading font-bold text-2xl">{p.name}</h3>
              <div className="mt-4 font-heading font-extrabold text-4xl tracking-tighter text-primary">{p.price}</div>
              <p className="mt-3 text-sm text-muted-foreground">{p.desc}</p>
              <ul className="mt-6 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm"><Check className="w-4 h-4 text-primary shrink-0" /> {f}</li>
                ))}
              </ul>
              <button data-testid={`pricing-cta-${p.name.toLowerCase()}`} onClick={go}
                className={`mt-8 w-full rounded-full py-3 text-sm font-semibold transition-all ${p.highlight ? "bg-primary text-primary-foreground hover:shadow-[0_0_30px_hsl(var(--primary)/0.5)]" : "border border-border hover:bg-secondary"}`}>
                Start Here
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
